import { Globe } from 'lucide-react';

export default function RegionalSettingsSection({ profile, updateProfile }) {
  const handleSave = () => {
    updateProfile({
      country: document.getElementById('country').value,
      timezone: document.getElementById('timezone').value,
      date_format: document.getElementById('date_format').value,
      time_format: document.getElementById('time_format').value,
      first_day_of_week: document.getElementById('week_start').value,
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <h2 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Globe className="w-5 h-5 text-teal-600" />
        Regional Settings
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select label="Country" id="country" defaultValue={profile?.country || 'United States'}>
          <option>United States</option>
        </Select>

        <Select label="Timezone" id="timezone" defaultValue={profile?.timezone || 'America/New_York'}>
          <option>(GMT-05:00) America/New_York (Eastern Time)</option>
          <option>(GMT-06:00) America/Chicago (Central Time)</option>
          <option>(GMT-07:00) America/Denver (Mountain Time)</option>
          <option>(GMT-07:00) America/Phoenix (Arizona - no DST)</option>
          <option>(GMT-08:00) America/Los_Angeles (Pacific Time)</option>
          <option>(GMT-09:00) America/Anchorage (Alaska)</option>
          <option>(GMT-10:00) Pacific/Honolulu (Hawaii)</option>
        </Select>

        <Select label="Date format" id="date_format" defaultValue={profile?.date_format || 'December 15, 2025'}>
          <option>December 15, 2025</option>
          <option>Dec 15, 2025</option>
          <option>12/15/2025</option>
        </Select>

        <Select label="Time format" id="time_format" defaultValue={profile?.time_format || '12 Hour (1:30 PM)'}>
          <option>12 Hour (1:30 PM)</option>
          <option>24 Hour (13:30)</option>
        </Select>

        <Select label="First day of week" id="week_start" defaultValue={profile?.first_day_of_week || 'Sunday'}>
          <option>Sunday</option>
          <option>Monday</option>
        </Select>
      </div>

      <button onClick={handleSave} className="mt-6 px-5 py-2.5 bg-teal-600 text-white rounded-lg text-xs font-bold">
        Save Regional Settings
      </button>
    </div>
  );
}

const Select = ({ label, children, ...props }) => (
  <div>
    <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
    <select className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm bg-white" {...props}>
      {children}
    </select>
  </div>
);